import React from 'react'
import "./index.css"
import { useNavigate } from 'react-router-dom'


export default function NotFound(){
    const navigate = useNavigate()
    //返回首页
    const toBack=()=>{
        navigate('/Index')
    }
    //制造多个404渲染页面
    let list = []
    for(let i = 0;i<80;i++){
        list.push(i)
    }
    return (
        <div>
            <main className='container'>
                {
                    list.map(res=>{
                        return <span key={'list-'+res} className='particle'>404</span>
                    })
                }
                <article className='content'>
                    <p>您输入的地址有误！</p>
                    <p>当前所在-<strong>404</strong> -</p>
                    <p>
                        <button onClick={toBack}>返回首页</button>
                    </p>
                </article>
            </main>
        </div>
    );
}

